
import { Component, Prop } from 'nuxt-property-decorator'
import Extractors from '@/helpers/validation/extractors'

@Component
export default class InputWithValidation extends Extractors {
  @Prop() value!: any
  @Prop({ default: 'text' }) type!: string
  @Prop() placeholder!: string
  @Prop() fieldName!: string
  @Prop() fieldNameLabel!: string
}
